import { Day } from './Day';
import { chunk, createElement, last } from '../utils';
import { monthNames, weekdayNames } from '../constants';
import addDays from 'date-fns/addDays';
import eachDayOfInterval from 'date-fns/eachDayOfInterval';
import endOfMonth from 'date-fns/endOfMonth';
import endOfWeek from 'date-fns/endOfWeek';
import getWeeksInMonth from 'date-fns/getWeeksInMonth';
import isSameDay from 'date-fns/isSameDay';
import isSameMonth from 'date-fns/isSameMonth';
import startOfMonth from 'date-fns/startOfMonth';
import startOfWeek from 'date-fns/startOfWeek';

const DAYS_IN_WEEK = 7;
const MAX_WEEKS_IN_A_MONTH = 6;

export function Month(month, config) {
	let { weekStartsOn, fixedWeeks } = config;

	let table = createElement('table');
	let header = createElement('div');
	let wrapper = createElement('div');

	header.className = config.classes.header;
	wrapper.className = config.classes.month;

	table.setAttribute('role', 'grid');

	let lastDayOfMonth = endOfMonth(month);
	let firstDayOfMonth = startOfMonth(month);
	let weeksInMonth = getWeeksInMonth(month, { weekStartsOn });

	let dates = eachDayOfInterval({
		end: endOfWeek(lastDayOfMonth, { weekStartsOn }),
		start: startOfWeek(firstDayOfMonth, { weekStartsOn }),
	});

	if (fixedWeeks && (weeksInMonth < MAX_WEEKS_IN_A_MONTH)) {
		let currentNumberOfDays = dates.length;
		let requiredNumberOfDays = DAYS_IN_WEEK * MAX_WEEKS_IN_A_MONTH;
		let numberOfDaysToAdd = requiredNumberOfDays - currentNumberOfDays;

		let lastDate = last(dates);

		dates.push(...eachDayOfInterval({
			start: addDays(lastDate, 1),
			end: addDays(lastDate, numberOfDaysToAdd),
		}));
	}

	const days = dates.map(date => createDay(date, config));

	function focusDate(date) {
		let day = days.find(day => isSameDay(day.date, date));

		if (!day) {
			return;
		}

		day.focus();
	}

	function render() {
		let rows = [];

		chunk(days, DAYS_IN_WEEK).forEach(week => {
			let row = createElement('tr');
			row.className = config.classes.week;
			row.append(...week.map(day => day.render()));
			rows.push(row);
		});

		let head = createHead(month, weekStartsOn);

		table.append(head, ...rows);
		wrapper.append(header, table);

		header.textContent = formatCaption(month);

		return wrapper;
	}

	function createDay(date, config) {
		let params = {
			outside: !isSameMonth(date, month),
		};

		return Day(date, params, config);
	}

	function formatCaption(date) {
		return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
	}

	function createHead(month, weekStartsOn) {
		const row = createElement('tr');
		const thead = createElement('thead');

		const names = [
			...weekdayNames.slice(weekStartsOn),
			...weekdayNames.slice(0, weekStartsOn),
		];

		names.forEach(day => {
			let element = createElement('th');
			element.textContent = day;
			row.append(element);
		});

		thead.append(row);

		return thead;
	}

	return { days, render, focusDate };
}
